import React, { forwardRef } from 'react';
import SemanticUIMessage from 'semantic-ui-react/dist/commonjs/collections/Message';

/* eslint-disable react/display-name */
const forwardRefAs = (as) => ({ forwardedRef, ...props }) => {
  const As = as;
  return <As ref={forwardedRef} {...props} />;
};

const ForwardableDiv = forwardRefAs('div');

const UIMessage = forwardRef((props, ref) => <SemanticUIMessage {...props} as={ForwardableDiv} forwardedRef={ref} />);

UIMessage.displayName = 'UIMessage';

export default UIMessage;
